export const CareersPageText = {
    fr: [
        "Chez SIMDEV, nous construisons plus que des solutions : nous créons un environnement où les idées, la collaboration et l’innovation prennent vie. Notre équipe passionnée évolue dans un espace moderne et convivial conçu pour favoriser la créativité et les échanges.",
        "Nous croyons au potentiel de chacun. C’est pourquoi nous encourageons le développement professionnel, la liberté d’expression et la collaboration entre talents.",
        "Et parce qu’une grande équipe se construit aussi en dehors du travail, nous cultivons une culture d’entreprise dynamique grâce à des événements et des moments partagés.",
        "Envie de contribuer, d’apprendre et de grandir avec nous ? Rejoignez l’aventure SIMDEV.",
    ],
    en: [
        "At SIMDEV, we build more than solutions — we create an environment where ideas, collaboration, and innovation thrive. Our passionate team works in a modern, welcoming space designed to encourage creativity and connection.",
        "We believe in everyone’s potential. That’s why we support professional growth, open communication, and collaboration across talents.",
        "And because strong teams are built beyond the workplace, we foster a vibrant company culture through events and shared moments.",
        "Looking to contribute, learn, and grow with us? Join the SIMDEV journey.",
    ]
}

export const JOB_OPENINGS = {
    en: [
        {
            id: 1,
            title: "Leasing Agent - South Shore – Residential Real Estate",
            description: "We are looking for a dynamic and motivated leasing agent to join our team and participate in the leasing of residential units on the South Shore of Montreal. The ideal candidate has an excellent sense of customer service, is organized, and enjoys working in a dynamic environment.",
            responsibilities: [
                "Respond to leasing inquiries (emails, calls, and messages)",
                "Schedule and conduct unit viewings",
                "Present units and answer questions from prospective tenants",
                "Assist candidates through the leasing process",
                "Follow up with prospects and complete leasing files",
                "Participate in achieving leasing objectives",
                "Assist the property manager in their duties"
            ],
            profile: [
                "Experience in real estate leasing, sales, or real estate customer service",
                "Good proficiency with digital tools and a CRM (Salesforce is an asset)",
                "Organizational skills, autonomy, and professionalism",
                "Driver's license and access to a vehicle (an asset)"
            ],
            conditions: [
                "Full-time position (flexible schedule including some evenings/weekends)",
                "Dynamic work environment in a growing real estate project"
            ]
        },
        {
            id: 3,
            title: "Leasing Agent – Residential Real Estate - North Shore - Quartier Oviv",
            description: "We are looking for a dynamic and motivated leasing agent to join our team and participate in the leasing of residential units for the Quartier Oviv project (1,350 units) in Charlemagne on the North Shore of Montreal.",
            responsibilities: [
                "Respond to leasing inquiries (emails, calls, and messages)",
                "Schedule and conduct unit viewings",
                "Present units and answer questions from prospective tenants",
                "Assist candidates through the leasing process",
                "Follow up with prospects and complete leasing files",
                "Participate in achieving leasing objectives"
            ],
            profile: [
                "Experience in real estate leasing, sales, or customer service",
                "Good proficiency with digital tools and communication platforms (Salesforce is an asset)",
                "Excellent communication skills, organizational skills, and autonomy",
                "Driver's license and access to a vehicle (an asset)"
            ],
            conditions: [
                "Full-time position (flexible schedule including some evenings/weekends)",
                "Dynamic work environment in a growing real estate project"
            ]
        },
        {
            id: 5,
            title: "Janitor / Maintenance Manager – North Shore – Quartier Oviv",
            description: "We are looking for a versatile janitor / maintenance manager to ensure the maintenance of phase 1 (144 units) of the Quartier Oviv project in Charlemagne. The ideal candidate is resourceful, reliable, and enjoys manual work.",
            responsibilities: [
                "Perform general maintenance of the buildings and common areas",
                "Carry out various minor repairs (plumbing, painting, hardware, etc.)",
                "Respond to tenant maintenance requests",
                "Conduct regular building inspections and report issues",
                "Participate in the preparation of units during tenant turnovers",
                "Coordinate certain interventions with external suppliers"
            ],
            profile: [
                "Minimum of 5 years of experience in building maintenance or general maintenance",
                "Skill in manual labor and basic repairs",
                "Organizational skills, autonomy, and good customer service",
                "Reliability and punctuality"
            ],
            conditions: [
                "Full-time position",
                "A stable job within a major project",
                "A professional and collaborative team"
            ]
        }
    ],
    fr: [
        {
            id: 1,
            title: "Agent(e) de location - Rive-sud – Immobilier résidentiel",
            description: "Nous sommes à la recherche d’un(e) agent(e) de location dynamique et motivé(e) pour se joindre à notre équipe et participer à la location d’unités résidentielles sur la Rive-Sud de Montréal. Le ou la candidat(e) idéal(e) possède un excellent sens du service à la clientèle, est organisé(e) et aime travailler dans un environnement dynamique.",
            responsibilities: [
                "Répondre aux demandes de location (courriels, appels et messages)",
                "Planifier et effectuer les visites des logements",
                "Présenter les unités et répondre aux questions des candidats locataires",
                "Assister les candidats dans le processus de location",
                "Effectuer le suivi avec les prospects et compléter les dossiers de location",
                "Participer à l’atteinte des objectifs de location",
                "Assister le gestionnaire immobilier dans ces tâches"
            ],
            profile: [
                "Expérience en location immobilière, vente ou service à la clientèle en immobilier",
                "Bonne maîtrise des outils numériques et d'un CRM (Salesforce un atout)",
                "Sens de l’organisation, autonomie et professionnalisme",
                "Permis de conduire et accès à un véhicule (un atout)"
            ],
            conditions: [
                "Poste à temps plein (horaire flexible incluant soirs/fins de semaine)",
                "Environnement de travail dynamique dans un projet immobilier en croissance"
            ]
        },
        {
            id: 3,
            title: "Agent(e) de location - Rive-Nord - Immobilier résidentiel",
            description: "Nous sommes à la recherche d’un(e) agent(e) de location dynamique et motivé(e) pour se joindre à notre équipe et participer à la location d’unités résidentielles dans le cadre du projet Quartier Oviv (1 350 unités) à Charlemagne sur la Rive-Nord de Montréal.",
            responsibilities: [
                "Répondre aux demandes de location (courriels, appels et messages)",
                "Planifier et effectuer les visites des logements",
                "Présenter les unités et répondre aux questions des candidats locataires",
                "Assister les candidats dans le processus de location",
                "Effectuer le suivi avec les prospects et compléter les dossiers de location",
                "Participer à l’atteinte des objectifs de location"
            ],
            profile: [
                "Expérience en location immobilière, vente ou service à la clientèle",
                "Bonne maîtrise des outils numériques et des plateformes de communication (Salesforce un atout)",
                "Excellentes aptitudes en communication, sens de l’organisation et autonomie",
                "Permis de conduire et accès à un véhicule (un atout)"
            ],
            conditions: [
                "Poste à temps plein (horaire flexible incluant soirs/fins de semaine)",
                "Environnement de travail dynamique dans un projet immobilier en croissance"
            ]
        },
        {
            id: 5,
            title: "Concierge / Responsable de maintenance – Rive-Nord – Quartier Oviv",
            description: "Nous sommes à la recherche d’un(e) concierge / responsable de maintenance polyvalent(e) pour assurer l’entretien de la phase 1 (144 unités) du projet Quartier Oviv à Charlemagne. Le ou la candidat(e) idéal(e) est débrouillard(e), fiable et aime le travail manuel.",
            responsibilities: [
                "Effectuer l’entretien général des immeubles et des espaces communs",
                "Réaliser diverses réparations mineures (plomberie, peinture, quincaillerie, etc.)",
                "Répondre aux demandes de maintenance des locataires",
                "Effectuer des inspections régulières des bâtiments et signaler les problèmes",
                "Participer à la préparation des logements lors des changements de locataires",
                "Coordonner certaines interventions avec des fournisseurs externes"
            ],
            profile: [
                "5 ans d’expérience minimum en entretien d’immeubles ou maintenance générale",
                "Habileté pour les travaux manuels et les réparations de base",
                "Sens de l’organisation, autonomie et bon service à la clientèle",
                "Fiabilité et ponctualité"
            ],
            conditions: [
                "Poste à temps plein",
                "Un emploi stable au sein d’un projet d’envergure",
                "Une équipe professionnelle et collaborative"
            ]
        }
    ]
}


export const CareersPageData = {
    CareersPageData_en: {
        title: {
            "text": "Join the SIMDEV family"
        },
        description: {
            "title": "Life at SIMDEV",
            text: CareersPageText.en
        },
        jobs: {
            title: "Open Positions",
            apply_button: "Apply Now",
            labels: {
                responsibilities: "Responsibilities",
                profile: "Required Profile",
                conditions: "Conditions"
            },
            openings: JOB_OPENINGS.en
        },
        button: {
            "text": "View Available Jobs"
        }
    },
    CareersPageData_fr: {
        title: {
            "text": "Rejoignez la famille SIMDEV"
        },
        description: {
            "title": "La vie chez SIMDEV",
            text: CareersPageText.fr
        },
        jobs: {
            title: "Postes disponibles",
            apply_button: "Postuler",
            labels: {
                responsibilities: "Responsabilités",
                profile: "Profil recherché",
                conditions: "Conditions"
            },
            openings: JOB_OPENINGS.fr
        },
        button: {
            "text": "Voir les postes disponibles"
        }
    }
}
